module.exports = __webpack_public_path__ + "static/media/datePickerCalendar.7a69dc9c.svg";